import styled from 'styled-components';

import { DateTimePicker, DateTimePickerSlotProps, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Dayjs } from 'dayjs';
import { useTheme } from '../../styles/theme';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  & .MuiTextField-root {
    & .MuiLabelInput-shrink {
      transform: 'translate(14px, -9px) scale(0.75)';
    }
  }

  & .MuiInputAdornment-root {
    padding-right: 8px;

    svg {
      font-size: 20px;
    }
  }
`;

export type ToolbarDateSelector = {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  onStartDateChange: (date: Dayjs | null) => void;
  onEndDateChange: (date: Dayjs | null) => void;
};

export const TableToolbarDate: React.FC<ToolbarDateSelector> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}) => {
  const theme = useTheme();
  const slotProps: DateTimePickerSlotProps<Dayjs, false> = {
    textField: {
      size: 'small',
      sx: {
        width: '230px',
        '& .MuiInputBase-root': {
          backgroundColor: theme.background.standard,
          height: '36px',
          padding: '0 8px',
        },
        '& .MuiInputBase-input': {
          padding: '0 6px',
        },
      },
    },
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Container>
        <DateTimePicker label='Start Date' value={startDate} onChange={onStartDateChange} slotProps={slotProps} />
        <DateTimePicker label='End Date' value={endDate} onChange={onEndDateChange} slotProps={slotProps} />
      </Container>
    </LocalizationProvider>
  );
};
